module.exports = __webpack_public_path__ + "img/magazine-japan-title.b4c4437a.png";